module.exports = __webpack_public_path__ + "dba2098a9ec3ebd7dffbbf80a4bf3586.md";